import { render, staticRenderFns } from "./ImportDropzone.vue?vue&type=template&id=438a16bf&scoped=true"
import script from "./ImportDropzone.vue?vue&type=script&lang=js"
export * from "./ImportDropzone.vue?vue&type=script&lang=js"
import style0 from "./ImportDropzone.vue?vue&type=style&index=0&id=438a16bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438a16bf",
  null
  
)

export default component.exports